const $window = $(window);
const breakPoint = 767;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//SPヘッダーの開閉
import {spHeaderToggle} from "../include/module";
spHeaderToggle();

//Headerスクロール時
import {scrolledHeader} from "../include/module";
scrolledHeader();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

$(function(){
    // if(navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)){
    //   $('.view-Attention').css({display:'block'});
    // }

    var isReverse = false;  //正面が逆かどうかのフラグを用意しておく

    if (navigator.userAgent.indexOf('Android') > 0) {
        //Androidなら正面設定を確認
        var orientation = screen.orientation || screen.mozOrientation || screen.msOrientation;
        if (orientation.type === "portrait-secondary" || orientation.type === "landscape-primary") {
            isReverse = true;
        }else{
          $('.view-Attention').css({display:'block'});
        }
    }

    $(window).on("lord orientationchange", function() {
        if(isReverse){
            orientCheckReverse();  //正面が逆の場合
        }else{
            orientCheck();  //正面が通常の場合
        }
    });

    $('.view-Attention .btn').click(function () {
      $('.view-Attention').fadeOut(200);
    });
});

//正面設定が通常の場合の縦横判定処理
function orientCheck() {
    var orientation = window.orientation;
    if (orientation === 0) {
    } else {
      $('.view-Attention').css({display:'none'});
    }
};

//正面設定が逆の場合の縦横判定処理
function orientCheckReverse() {
    var orientation = window.orientation;
    if (orientation === 0) {
    } else {
      $('.view-Attention').css({display:'none'});
    }
};


// WEBPACK FOOTER //
// ./src/assets/js/mosaicart/script.js